import { maxWidth600 } from "themes/default/breakpoints"
import { theme } from "themes/default/theme"
import { styles as LS } from "components/Tools/LibraryModal/styles/LibraryModal.styles"

export const styles = {
  container: {
    ...theme.mixins.modalContent,
    overflow: "visible",
    pt: 0,
    px: 1,
    pb: 1,
    maxWidth: 1200,
  },
  closeButton: LS.closeButton,
  mainImage: LS.mainImage,
  content: {
    ...LS.content,
    pt: "10px!important",
    mt: -1,
  },
  searchInput: LS.searchInput,
  searchBox: LS.searchBox,
  inputButton: LS.inputButton,
  notesBoxRight: (theme) => ({
    backgroundColor: theme.palette.background.default,
    verticalAlign: "top",
    position: "relative",
    width: `calc(100% - 255px)`,
    // height: `calc(100% - 115px)`,
    maxHeight: `calc(100% - 115px)`,
    minHeight: 450,
    p: 1,
    [maxWidth600]: {
      width: `100%`,
      minHeight: "100%",
      overflow: "hidden",
    },
  }),
  icon: {
    color: theme.palette.primary.main,
    cursor: "pointer",
  },
  saveButton: {
    textTransform: "none",
    flex: 1 / 12,
    height: 25,
  },
  key: (theme) => ({
    width: 25,
    height: 25,
    backgroundColor: "#9e9e9e",
    borderRadius: "2px",
    color: theme.palette.background.default,
    lineHeight: "25px",
    textTransform: "none",
    fontSize: 14,
    mr: 0.25,
    "&:hover": {
      backgroundColor: "#757575",
    },
  }),
  notesBoxLeft: {
    [maxWidth600]: {
      overflowX: "scroll",
    },
  },
  saveButtonTour: {
    zIndex: 10000,
  },
}
